module.exports = __webpack_public_path__ + "static/media/step-check.a4d58017.svg";